import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgPerson = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" d="M3.9 8.782a5.914 5.914 0 0 0 8.2 0 8 8 0 0 1 3.9 6.87c0 .117 0 .233-.007.348H.007C0 15.885 0 15.769 0 15.652a8 8 0 0 1 3.9-6.87zm4.1.261a4.522 4.522 0 1 1 4.522-4.521A4.522 4.522 0 0 1 8 9.043z" /></svg>;
const ForwardRef = forwardRef(SvgPerson);
export default ForwardRef;